// extracted by mini-css-extract-plugin
export var button = "_ew-4";
export var hasDarkBackground = "_ew-7";
export var hasLightBackground = "_ew-6";
export var iconWrapper = "_ew-0";
export var large = "_ew-2";
export var medium = "_ew-1";
export var small = "_ew-5";
export var xsmall = "_ew-3";